import { API } from "redux/api";

// SignUp
export function signUp(userDetails) {
  return API({
    method: "post",
    url: "",
    data: userDetails,
  });
}

export function resetPassword(authDetails) {
  return API({
    method: "post",
    url: "/merchants/resetPassword",
    data: authDetails,
  });
}

// SignIn
export function signIn(userDetails) {
  return API({
    method: "post",
    url: "/merchants/staff/login",
    data: userDetails,
  });
}

// OTP
export function verifyOTP(details) {
  return API({
    method: "post",
    url: "",
    data: details,
  });
}

// Get Restaurant Details
export function getRestaurantDetails(id) {
  return API({
    method: "get",
    url: "/merchants/location/" + id + "/details",
  });
}

// Logout
export function logout() {
  return API({
    method: "post",
    url: "/merchants/staff/logout/v2",
    data: {},
  });
}
